import { render, staticRenderFns } from "./faceIdTip.vue?vue&type=template&id=4bfb3698&scoped=true"
import script from "./faceIdTip.vue?vue&type=script&lang=js"
export * from "./faceIdTip.vue?vue&type=script&lang=js"
import style0 from "./faceIdTip.vue?vue&type=style&index=0&id=4bfb3698&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bfb3698",
  null
  
)

export default component.exports